import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import LiquidText from './LiquidText';

// Resolve o documento na matriz em cada abertura: o atalho acompanha as revisões.
const normalizar = codigo => String(codigo || '').replace(/^PR[._]/i, 'P_').replace(/\./g, '_').toUpperCase();

export default function ProcedimentoLink({ codigo, titulo }) {
    const { hasPermission } = useAuth();
    const [aAbrir, setAAbrir] = useState(false);
    const [erro, setErro] = useState('');

    if (!hasPermission('sistema-integrado')) return null;

    const abrir = async () => {
        if (aAbrir) return;
        // Abrir no clique evita que o navegador bloqueie o PDF após os pedidos.
        const janela = window.open('about:blank', '_blank');
        if (!janela) {
            setErro('Permita abrir um novo separador para consultar o procedimento.');
            return;
        }
        janela.opener = null;
        janela.document.title = titulo;
        janela.document.body.textContent = 'A abrir o procedimento…';
        setAAbrir(true);
        setErro('');
        try {
            const { data } = await api.get('/sistema-integrado/documentos');
            const candidatos = data.filter(d => normalizar(d.codigo) === normalizar(codigo) && d.estado === 'em_vigor');
            if (candidatos.length !== 1 || !candidatos[0].ficheiro_url) {
                throw new Error('Não foi possível identificar uma versão em vigor. Consulte a matriz de documentos.');
            }
            const resposta = await api.get(`/sistema-integrado/documentos/${candidatos[0].id}/ficheiro`, { responseType: 'blob' });
            const url = URL.createObjectURL(new Blob([resposta.data], { type: 'application/pdf' }));
            if (!janela.closed) janela.location.replace(url);
            setTimeout(() => URL.revokeObjectURL(url), 60000);
        } catch (e) {
            if (!janela.closed) janela.close();
            setErro(e.response ? 'Não foi possível abrir o procedimento. Tente novamente.' : e.message);
        } finally {
            setAAbrir(false);
        }
    };

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <button type="button" className="btn-secondary" data-liquid-secondary="true"
                disabled={aAbrir} onClick={abrir} title={`Abrir a versão em vigor — ${codigo}`}>
                <LiquidText>📄</LiquidText> {aAbrir ? 'A abrir…' : titulo}
            </button>
            {erro && <span role="alert" style={{ color: '#b91c1c', fontSize: '0.85rem' }}>{erro}</span>}
        </span>
    );
}
